import Vue from "vue"
import Router from "vue-router"


Vue.use(Router)
const App = { template: '<App>'}
export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/:show",
      name: "App",
      component: App
    },
  ]
})



// WEBPACK FOOTER //
// ./src/Router.js